// 实勘接口
import { get } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
// homeClient客户端, testwikidatacenter服务端
const { testwikidatacenter, homeClient } = apiList

export default axios => ({
  // init初始化
  init: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/survey/list/index/init-v1`, params),
  // tabs切换
  switchInit: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/survey/list/index/more-v1`, params),
  // 详情页初始化
  detailsInit: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/survey/detail/index/init-v1`, params)
})
